import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class RegisterService {
  constructor() {
    this.endpoints = createPrefix('/registration/register', {
      beneficiary: '/beneficiary',
      user: '/user',
    })
  }

  static create() {
    return new RegisterService()
  }

  async registerBeneficiary(beneficiary) {
    const registerPath = this.endpoints.beneficiary()
    const { data } = await axios.post(registerPath, beneficiary)
    return data
  }

  async registerUser(user) {
    const registerPath = this.endpoints.user()
    const { data } = await axios.post(registerPath, user)
    return data
  }

  async requestDataDeletion(formData) {
    const registerPath = '/registration/request-removal'
    const { data } = await axios.post(registerPath, formData)
    return data
  }
}
